import React from 'react';
import Sponsors from 'components/home/sponsors';

export default function SectionReferencesWithLogo({ section }) {
  return <Sponsors section={section} />;
}
